import {
  AccessTime as AccessTimeIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  Close as CloseIcon,
  CompareArrows as CompareArrowsIcon,
  DoneAll as DoneAllIcon,
  HourglassEmpty as HourglassEmptyIcon,
  Message as MessageIcon,
  Print as PrintIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Chip,
  Grid,
  IconButton,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";

import Comanda from "../../../../../imagens/iconeComanda.svg";
import DeliveryIcon from "../../../../../imagens/iconeDelivery";
import Mesa from "../../../../../imagens/iconeMesa.svg";
import Sequencial from "../../../../../imagens/iconeSequencial";

import BrowserNotification from "../../../../../utils/BrowserNotification";
import ForList from "../../../../Skeleton/ForList";
import columns from "./columns.confg";
import MenuSituacao from "./MenuSituacao";
import AuthService from "../../../../../AuthService";
import { useConfirm } from "../../../../../components/DialogConfirm";
import { useSnackbar } from "notistack";

const PedidosTable = ({
  pedidos,
  buscando,
  rowsPerPage,
  page,
  totalCountPedidos,
  handleCancel,
  setPage,
  buscarPedidosUtilizandoPesquisa,
  handlePrintOut,
  setPedidos,
  handleMarcarComoImpresso,
  handleOpenInfo,
  setPedidoSelecionado,
  setRowsPerPage,
  Utils,
}) => {
  const confirm = useConfirm();
  const { enqueueSnackbar } = useSnackbar();
  const getAvatarIcon = (tipo) => {
    switch (tipo) {
      case "MESA":
        return <Avatar src={Mesa} />;
      case "COMANDA":
        return <Avatar src={Comanda} />;
      case "SEQUENCIAL":
        return <Sequencial style={{ width: "2.5rem", height: "2.5rem" }} />;
      case "DELIVERY":
        return <DeliveryIcon style={{ width: "2.5rem", height: "2.5rem" }} />;
      default:
        return null;
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    buscarPedidosUtilizandoPesquisa();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    buscarPedidosUtilizandoPesquisa();
  };

  const openPedido = (pedido) => {
    setPedidoSelecionado(pedido);
    handleOpenInfo();
  };

  const handleClose = async (pedido) => {
    const confirmado = await confirm({
      message: "Deseja fechar o pedido ?",
    });
    if (!confirmado) return;

    const service = new AuthService();
    const pedidosBody = [{ id: pedido.id }];
    service
      .post(`/pedido/marcarComoPago`, pedidosBody)
      .then((retorno) => {
        enqueueSnackbar("Pedido fechado com sucesso", { variant: "success" });
        pedido.status = retorno[0].status;
        setPedidos([...pedidos]);
      })
      .catch((err) => {
        enqueueSnackbar(`Falha ao fechar pedido: ${err}`, { variant: "error" });
        console.error(err);
      });
  };

  const handleReopen = async (pedido) => {
    const confirmado = await confirm({
      message: "Deseja reabrir o pedido ?",
    });
    if (!confirmado) return;

    const service = new AuthService();
    const pedidosBody = [{ id: pedido.id }];
    service
      .post(`/pedido/marcarComoNaoPago`, pedidosBody)
      .then((retorno) => {
        enqueueSnackbar("Pedido reaberto com sucesso", { variant: "success" });
        pedido.status = retorno[0].status;
        setPedidos([...pedidos]);
      })
      .catch((err) => {
        enqueueSnackbar(`Falha ao reabrir pedido: ${err}`, {
          variant: "error",
        });
        console.error(err);
      });
  };

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align={column.align}
                style={{ minWidth: column.minWidth }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {buscando ? (
            <TableRow>
              <TableCell colSpan={12}>
                <ForList rows={rowsPerPage} height={50} />
              </TableCell>
            </TableRow>
          ) : (
            pedidos.map((pedido) => (
              <TableRow
                key={pedido.id}
                style={{
                  opacity: pedido.situacao === "CANCELADO" ? "0.2" : "1",
                }}
              >
                <TableCell>
                  {pedido.situacao && (
                    <MenuSituacao handleCancel={handleCancel} pedido={pedido} />
                  )}
                </TableCell>

                <TableCell>
                  {getAvatarIcon(pedido.identificador.tipo)}
                </TableCell>

                <TableCell>
                  <Grid container spacing={1} direction="column">
                    <Grid>
                      <Tooltip
                        title={
                          pedido.statusImpressao === "IMPRESSO"
                            ? "Liberar nova impressão"
                            : "Marcar como impresso"
                        }
                        placement="top"
                      >
                        <Chip
                          onClick={
                            pedido.statusImpressao === "IMPRESSO"
                              ? () => handlePrintOut(pedido)
                              : () => handleMarcarComoImpresso(pedido)
                          }
                          clickable
                          label={
                            pedido.statusImpressao === "IMPRESSO"
                              ? "Impresso"
                              : "Pendente"
                          }
                          icon={<PrintIcon fontSize="small" />}
                          size="small"
                          color={
                            pedido.statusImpressao === "IMPRESSO"
                              ? "default"
                              : "primary"
                          }
                        />
                      </Tooltip>
                    </Grid>

                    <Grid>
                      <Chip
                        label={
                          pedido.statusIntegracao === "INTEGRADO"
                            ? "Integrado"
                            : "Integração"
                        }
                        icon={
                          pedido.statusIntegracao === "INTEGRADO" ? (
                            <DoneAllIcon fontSize="small" />
                          ) : (
                            <HourglassEmptyIcon fontSize="small" />
                          )
                        }
                        title={
                          pedido.statusIntegracao === "INTEGRADO"
                            ? "Pedido integrado"
                            : "Aguardando integração"
                        }
                        size="small"
                        color={
                          pedido.statusIntegracao === "INTEGRADO"
                            ? "default"
                            : "primary"
                        }
                      />
                    </Grid>
                  </Grid>
                </TableCell>

                <TableCell>
                  <ListItemText
                    primary={
                      <Typography color="textPrimary">
                        {pedido.identificador.numero}
                      </Typography>
                    }
                    secondary={pedido.identificador.tipo}
                  />
                </TableCell>

                <TableCell>
                  {pedido.identificadorSecundario && (
                    <ListItemText
                      primary={
                        <Typography color="textPrimary">
                          {pedido.identificadorSecundario}
                        </Typography>
                      }
                      secondary={
                        ["DELIVERY", "SEQUENCIAL"].includes(
                          pedido.identificador.tipo
                        )
                          ? "Sequencial"
                          : ""
                      }
                    />
                  )}
                </TableCell>

                <TableCell>
                  <Box display="flex">
                    <Box p={1}>
                      <Typography color="textPrimary">
                        {pedido.nomeCliente}
                      </Typography>
                      <Typography color="textSecondary" variant="caption">
                        {pedido.pessoa?.telefone}
                      </Typography>
                    </Box>

                    {pedido.tokenMessage && (
                      <Box p={1}>
                        <Tooltip title="Push ativado">
                          <MessageIcon fontSize="small" />
                        </Tooltip>
                      </Box>
                    )}
                  </Box>
                  <BrowserNotification />
                </TableCell>

                <TableCell align="center">
                  <Typography align="center" color="textPrimary">
                    {pedido.horarioAgendamento && (
                      <AccessTimeIcon color="secondary" />
                    )}
                  </Typography>
                  <Typography color="textSecondary" variant="caption">
                    {Utils.formatarDataHora(
                      pedido.horarioAgendamento,
                      pedido.empresa.timezone
                    )}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography color="textPrimary">
                    {Utils.formatarDataHora(
                      pedido.dataPedido,
                      pedido.empresa.timezone
                    )}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography align="right" color="textPrimary">
                    {Utils.formatNumber(Utils.getTotalPedido(pedido))}
                  </Typography>
                </TableCell>

                <TableCell align="right">
                  <Box display="flex">
                    <Tooltip title="VER PEDIDO" placement="top">
                      <IconButton
                        onClick={() => openPedido(pedido)}
                        size="large"
                      >
                        <VisibilityIcon color="primary" />
                      </IconButton>
                    </Tooltip>

                    {pedido.status === "PAGO" ? (
                      <Tooltip title="REABRIR PEDIDO" placement="top">
                        <IconButton
                          onClick={() => handleReopen(pedido)}
                          size="large"
                        >
                          <CompareArrowsIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="FECHAR PEDIDO" placement="top">
                        <IconButton
                          onClick={() => handleClose(pedido)}
                          size="large"
                        >
                          <AccountBalanceWalletIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                    )}

                    <Tooltip title="CANCELAR PEDIDO" placement="top">
                      <IconButton
                        onClick={() => handleCancel(pedido)}
                        size="large"
                      >
                        <CloseIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={totalCountPedidos}
        labelRowsPerPage="Linhas por página"
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
};

export default PedidosTable;
